const PagePresentations = {
  PAGE: 'Page',
  MODAL: 'Modal',
  SYSTEM: 'System',
};

module.exports = PagePresentations;
